import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card, CardBody, CardImg, CardTitle, CardText,
  Container, Row, Col,
} from "reactstrap";
import { provincesRepo } from "data/repositories/provincesRepo";
import AdBannerSlider from "components/AdBannerSlider";
import ThemeBadge from "components/ThemeBadge";

const PROVINCE_IMAGES = {
  trabzon: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=600&q=80",
  rize: "https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=600&q=80",
  artvin: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=600&q=80",
  samsun: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&q=80",
  sinop: "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=600&q=80",
  ordu: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80",
};

export default function Home() {
  const [provinces, setProvinces] = useState([]);

  useEffect(() => {
    setProvinces(provincesRepo.list());
  }, []);

  return (
    <>

      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <Row className="align-items-center">
            <Col>
              <h1 className="text-white mb-1">Karadeniz'i keşfet</h1>
              <p className="text-white opacity-8 mb-0">18 şehir, temalara göre hikayeler ve fırsatlar.</p>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="mt--6" fluid>

        <Row className="mb-4">
          <Col lg={6} md={6} xs={12} className="mb-3">
            <Card className="shadow" tag={Link} to="/admin/businesses" style={{ textDecoration: "none" }}>
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="icon icon-shape bg-primary text-white rounded-circle shadow mr-3">
                    <i className="fas fa-store" />
                  </div>
                  <div>
                    <h3 className="mb-0">İşletmeleri keşfet</h3>
                    <small className="text-muted">Oteller, restoranlar ve daha fazlası</small>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={6} md={6} xs={12} className="mb-3">
            <Card className="shadow" tag={Link} to="/admin/deals" style={{ textDecoration: "none" }}>
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="icon icon-shape bg-success text-white rounded-circle shadow mr-3">
                    <i className="fas fa-tags" />
                  </div>
                  <div>
                    <h3 className="mb-0">Fırsatları gör</h3>
                    <small className="text-muted">Şehir + tema ile filtrele</small>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>


        <AdBannerSlider placement="home" />


        <h3 className="mb-3">Öne çıkan şehirler</h3>
        <Row>
          {provinces.map((p) => (
            <Col key={p.id} lg={4} md={6} xs={12} className="mb-4">
              <Card className="shadow" tag={Link} to={`/admin/provinces/${p.id}`} style={{ textDecoration: "none" }}>
                {PROVINCE_IMAGES[p.id] && (
                  <CardImg top src={PROVINCE_IMAGES[p.id]} alt={p.name} style={{ height: 160, objectFit: "cover" }} />
                )}
                <CardBody>
                  <CardTitle tag="h4" className="mb-1">{p.name}</CardTitle>
                  <CardText className="text-muted small mb-2">{p.slogan}</CardText>
                  <div>
                    {(p.themes || []).slice(0, 3).map((t) => (
                      <ThemeBadge key={t} theme={t} />
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}
